export const SUPER_ADMIN = "SUPER_ADMIN";
export const ADMIN = "ADMIN";
export const USER = "USER";
